import CityPageTemplate from "../city-template/CityPageTemplate";
import { centennialConfig } from "./data";

export default function CentennialPage() {
  return <CityPageTemplate config={centennialConfig} />;
}